var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3129_3864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.85059 0 0 9.85059 0 22C0 34.1493 9.85059 44 22 44C34.1493 44 44 34.1493 44 22C44 9.85059 34.1493 0 22 0Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.85059 0 0 9.85059 0 22C0 34.1493 9.85059 44 22 44C34.1493 44 44 34.1493 44 22C44 9.85059 34.1493 0 22 0ZM30.1694 22.249L17.7944 29.6349C17.7058 29.6887 17.593 29.6914 17.5017 29.6376C17.4131 29.5866 17.3567 29.4913 17.3567 29.3852V21.9992V14.6132C17.3567 14.5086 17.4131 14.4119 17.5017 14.3608C17.593 14.3084 17.7058 14.3111 17.7944 14.3634L30.1694 21.7508C30.258 21.8011 30.3104 21.8984 30.3104 21.9991C30.3104 22.102 30.2581 22.1974 30.1694 22.249Z",
    fill: "#FF5501"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3129_3864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.6490bf8cd6ea32c0682c3fbba4e7b809.svg";
export { ForwardRef as ReactComponent };